import UIStore from '../store/UIStore'
import * as apiService from '../_services/api.service'

export async function getAll() {
  return await apiService.get(`tutorials/env=${UIStore.environnement_id}&lang=${UIStore.lang}`);
}
